import { AutoComplete } from '@openx/components-core/lib/AutoComplete/AutoComplete.tsx';
import { GeographicOption } from '@openx/types/targeting/geographic.ts';
import pick from 'lodash/pick';
import { useTranslation } from 'react-i18next';
import { useCustomOptionsContext } from '../../../utils/hooks/useCustomOptionsContext.tsx';

type LocationTypeProps = {
  onChange: (type: GeographicOption) => void;
  value: GeographicOption;
};

export const LocationType = (props: LocationTypeProps) => {
  const { onChange, value } = props;
  const { t } = useTranslation();
  const customOptions = useCustomOptionsContext<GeographicOption>();

  let labels: Record<string, string> = {
    [GeographicOption.BOUNDING_BOX]: t('Bounding Box'),
    [GeographicOption.INCLUDES]: t('Location'),
    [GeographicOption.CIRCLES]: t('Location Radius'),
    [GeographicOption.SOURCE]: t('Location Source'),
  };

  if (customOptions) {
    labels = pick(labels, customOptions.availableOptions);
  }

  return (
    <AutoComplete
      textFieldProps={{ label: t('Location Type') }}
      options={Object.keys(labels)}
      renderOptions={{
        dataTest: 'location-type-option',
      }}
      getOptionLabel={option => labels[option]}
      textFieldReadOnly
      disableClearable
      filterOptions={option => option}
      onChange={(_, value) => onChange(value as GeographicOption)}
      value={value}
      data-test="location-type"
    />
  );
};
